import { FieldError } from 'react-hook-form';
import { ErrorMessages } from './consts';

export const removeOtherErrorsIfThereIsFieldRequiredError = (
  error: FieldError
): FieldError => {
  if (Array.isArray((error.types as Record<string, unknown>)?.custom)) {
    const custom = (error.types as Record<string, Array<string>>).custom;

    const messages = new Set<string>();
    if (typeof error.message === 'string') messages.add(error.message);
    custom.forEach((customError: string) => messages.add(customError));

    if (Array.from(messages).includes(ErrorMessages.FIELD_IS_REQUIRED)) {
      return {
        ...error,
        message: ErrorMessages.FIELD_IS_REQUIRED,
        types: { custom: [ErrorMessages.FIELD_IS_REQUIRED] },
      };
    }

    return error;
  }

  if (error.type === 'too_small') {
    return {
      ...error,
      message: ErrorMessages.FIELD_IS_REQUIRED,
      types: {
        custom: [ErrorMessages.FIELD_IS_REQUIRED],
        [error.type]: ErrorMessages.FIELD_IS_REQUIRED,
      },
    };
  }

  return error;
};
